import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, CheckCircle, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { mockData } from '../mock';

const Pricing = () => {
  return (
    <div className="min-h-screen bg-slate-950 pt-20">
      {/* Hero Section */}
      <section className="py-24 bg-gradient-to-b from-slate-900 to-slate-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Tarifs
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Transparence et flexibilité pour tous vos déplacements
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-24">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-block px-6 py-3 bg-amber-600/10 border border-amber-600/30 rounded-full mb-6">
              <span className="text-amber-500 font-medium">Tarification sur Mesure</span>
            </div>
            <h2 className="text-4xl font-bold text-white mb-6">
              Des Tarifs Adaptés à Vos Besoins
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              {mockData.pricing.note}
            </p>
          </div>

          {/* Features */}
          <Card className="bg-slate-900 border-slate-800 mb-12">
            <CardContent className="p-8">
              <h3 className="text-2xl font-bold text-white mb-6 text-center">
                Ce qui est Inclus
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {mockData.pricing.features.map((feature) => (
                  <div key={feature} className="flex items-center space-x-3">
                    <CheckCircle className="w-5 h-5 text-amber-500 flex-shrink-0" />
                    <span className="text-gray-300">{feature}</span>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>

          {/* Price Examples */}
          <div className="mb-12">
            <h3 className="text-2xl font-bold text-white mb-6 text-center">
              Exemples de Trajets
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {mockData.pricing.examples.map((example) => (
                <Card key={example.route} className="bg-slate-900 border-slate-800 hover:border-amber-600/50 transition-all duration-300">
                  <CardContent className="p-6">
                    <div className="flex justify-between items-center">
                      <div>
                        <p className="text-white font-semibold mb-1">{example.route}</p>
                        <p className="text-gray-400 text-sm">{example.estimation}</p>
                      </div>
                      <ArrowRight className="w-5 h-5 text-amber-500" />
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>

          {/* Info Box */}
          <Card className="bg-amber-600/10 border-amber-600/30">
            <CardContent className="p-8 text-center">
              <h3 className="text-xl font-bold text-white mb-4">
                Comment Obtenir un Devis ?
              </h3>
              <p className="text-gray-300 mb-6 max-w-2xl mx-auto">
                Remplissez notre formulaire de contact ou appelez-nous directement. 
                Nous vous répondrons dans les plus brefs délais avec un tarif personnalisé 
                adapté à votre trajet et vos besoins.
              </p>
              <Link to="/contact">
                <Button className="bg-amber-600 hover:bg-amber-700 text-white text-lg px-8 py-4 transition-all duration-300 hover:shadow-lg hover:shadow-amber-600/50">
                  <Phone className="w-5 h-5 mr-2" />
                  Demander un Devis Gratuit
                </Button>
              </Link>
            </CardContent>
          </Card>

          {/* Additional Info */}
          <div className="mt-12 text-center">
            <p className="text-gray-400 text-sm">
              Les tarifs peuvent varier en fonction de la distance, de la durée, du type de véhicule et des services additionnels.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-slate-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Une Question sur Nos Tarifs ?
          </h2>
          <p className="text-gray-400 text-lg mb-8">
            Notre équipe est à votre disposition pour répondre à toutes vos questions
          </p>
          <Link to="/contact">
            <Button className="bg-amber-600 hover:bg-amber-700 text-white text-lg px-8 py-6 transition-all duration-300">
              Contactez-Nous
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Pricing;
